// Module
var code = "<h2 id=\"endorsers\">Endorsers</h2> <p><strong>Endorsers</strong> can complete and print the <a href=\"/documents/servicing/pa/release-form.pdf\">Account Authorizations Agreement</a>, sign, and mail to the address provided on form.</p> ";
// Exports
export default code;